import { HttpServices } from '../../Helper';
import { config } from '../../config';

const baseURL = `${config.server_address}/CrmDfm/PartnerHub`;

const GetFilteredVendorClientTrackingsAPI = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/GetFilteredVendorClientTrackings`,
    body
  );
  return result;
};

const ExportVendorClientTrackingReportAPI = async (filter, exportType) => {
  const result = await HttpServices.post(
    `${baseURL}/ExportVendorClientTrackingReport`,
    {filter, exportType}
  );
  return result;
};

const CreateVendorClientTrackingAPI = async (body) => {
  const result = await HttpServices.get(
    `${baseURL}/CreateVendorClientTracking`,body
  );
  return result;
};

const GetVendorClientTrackingByIdAPI = async (trackingId) => {
  const result = await HttpServices.get(
    `${baseURL}/GetVendorClientTrackingById/${trackingId}`,
  );
  return result;
};
const UpdateVendorClientTracking = async (trackingId , body) => {
  const result = await HttpServices.put(
    `${baseURL}/UpdateVendorClientTracking/${trackingId}`, body
  );
  return result;
};
const DeleteVendorClientTrackingAPI = async (trackingId) => {
  const result = await HttpServices.delete(
    `${baseURL}/DeleteVendorClientTracking/${trackingId}`,
  );
  return result;
};

export {
  GetFilteredVendorClientTrackingsAPI ,
  CreateVendorClientTrackingAPI ,
  GetVendorClientTrackingByIdAPI , 
  UpdateVendorClientTracking ,
  ExportVendorClientTrackingReportAPI , 
  DeleteVendorClientTrackingAPI ,
};
